import styled from 'styled-components';
import { media } from '../../common/styles/styleUtil';

interface HeroImageWrapperProps {
  isOnProjectPage: boolean;
}
export const HeroImageWrapper = styled.div<HeroImageWrapperProps>`
  width: 100%;
  height: ${(props) => (props.isOnProjectPage ? 350 : 300)}px;
  min-height: auto;
  padding: 0;
  border: none;
  clear: both;
  ${media.xs`
    height: 140px;
  `};
  img {
    display: block;
    max-width: 1140px;
    margin: 0 auto;
    height: 100%;
    object-fit: cover;
  }
`;
